<template>
  <bita-modal
    id="gamification-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="number"
              name="from"
              label="از"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.from"
            />
            <bita-input
              type="number"
              name="to"
              label="تا"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.to"
            />
            <bita-select-simple
              label="نوع"
              name="type"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { id: 1, name: 'مبلغ ثابت' },
                { id: 2, name: 'درصد' },
              ]"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.type"
            />
            <bita-input
              v-if="formData.type == 1"
              type="number"
              name="value"
              label="مقدار"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.value"
            />
            <bita-input
              v-else
              type="number"
              name="value"
              label="مقدار"
              min="0"
              max="100"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.value"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="create"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
import { gamificationsApi } from "@/api/apiManagement.js";

export default {
  data() {
    return {
      colWidth: "col-lg-3",
      formData: {},
      isLoadingModal: false,
      title: "",
    };
  },
  methods: {
    setInitialData(_data) {
      this.formData = _data;
      if (_data && _data.id) this.title = `ویرایش`;
      else this.title = `افزودن`;
    },
    create() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoadingModal = true;
          gamificationsApi
            .create(this.formData)
            .then((res) => {
              this.$izitoast("success", "موفق!", res.data.message);
              this.$toggleModal("#gamification-form");
              this.$emit("load-data");
            })
            .finally(() => (this.isLoadingModal = false));
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoadingModal = true;
          gamificationsApi
            .update(this.formData.id, this.formData)
            .then((res) => {
              this.$izitoast("success", "موفق!", res.data.message);
              this.$toggleModal("#gamification-form");
              this.$emit("load-data");
            })
            .finally(() => (this.isLoadingModal = false));
        }
      });
    },
    reset() {
      this.formData = {};
    },
  },
};
</script>
